"use client";
import { IconDiscord as o } from "./socials/IconDiscord.js";
import { IconFacebook as r } from "./socials/IconFacebook.js";
import { IconfMailRu as m } from "./socials/IconfMailRu.js";
import { IconGmail as t } from "./socials/IconGmail.js";
import { IconGoogle as i } from "./socials/IconGoogle.js";
import { IconInstagram as n } from "./socials/IconInstagram.js";
import { IconLine as p } from "./socials/IconLine.js";
import { IconOnlyfans as a } from "./socials/IconOnlyfans.js";
import { IconOutlook as c } from "./socials/IconOutlook.js";
import { IconPasskey as f } from "./socials/IconPasskey.js";
import { IconPatreon as I } from "./socials/IconPatreon.js";
import { IconReddit as e } from "./socials/IconReddit.js";
import { IconSnapchat as s } from "./socials/IconSnapchat.js";
import { IconTelegram as d } from "./socials/IconTelegram.js";
import { IconTiktok as l } from "./socials/IconTiktok.js";
import { IconTwitter as k } from "./socials/IconTwitter.js";
import { IconVk as g } from "./socials/IconVk.js";
import { IconWhatsApp as u } from "./socials/IconWhatsApp.js";
import { IconYahoo as y } from "./socials/IconYahoo.js";
import { IconYandex as h } from "./socials/IconYandex.js";
import { IconYoutube as w } from "./socials/IconYoutube.js";
import { IconAndroid as O } from "./systems/IconAndroid.js";
import { IconApple as b } from "./systems/IconApple.js";
import { IconWindows as T } from "./systems/IconWindows.js";
const K = {
  android: O,
  apple: b,
  discord: o,
  facebook: r,
  gmail: t,
  google: i,
  instagram: n,
  line: p,
  mailru: m,
  onlyfans: a,
  outlook: c,
  passkey: f,
  patreon: I,
  reddit: e,
  snapchat: s,
  telegram: d,
  tiktok: l,
  twitter: k,
  vk: g,
  whatsapp: u,
  windows: T,
  yahoo: y,
  yandex: h,
  youtube: w
};
export {
  K as ICON_COMPONENTS
};
